import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import useHttpHook from "../../../Hooks/HttpHook";
import {
  ChangeGuardPassword,
  EditGuardApi,
  GetGuardById,
} from "../../../utils/ApiConstant";
import { GuardLanguage } from "../../../utils/Languages";
import MainComponentWrapper from "../../Common/MainComponentWrapper";
import ModalWrapper from "../../Common/Portals/ModalWrapper";
import Input from "../../UiElement/FormElement/Input";
import { toast } from "react-toastify";
import { showErrorToast } from "../../../utils/notify";

const ChangePassword = ({ guard, onClose }) => {
  const [loading, sendRequest, error] = useHttpHook();
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  useEffect(() => {
    if (error) {
      if (toast.isActive(error) === false) {
        showErrorToast(error);
        if (error === "You are unAuthrised") {
          window.location.href = `${process.env.REACT_APP_MERCH_URL}/login`;
        }
      }
    }
  }, [error]);

  console.log(guard, "--------- guard ----------");
  //   const [dobError, setDobError] = useState("");
  //   const gender = [
  //     {
  //       title: "male",
  //     },
  //     {
  //       title: "female",
  //     },
  //     {
  //       title: "other",
  //     },
  //   ];

  //   useEffect(() => {
  //     getGuardDetails();
  //   }, []);

  //   useEffect(() => {
  //     if (error) {
  //       if (toast.isActive(error) === false) {
  //         showErrorToast(error);
  //       }
  //     }
  //   }, [error]);
  //   const getGuardDetails = async () => {
  //     try {
  //       const res = await sendRequest(`${GetGuardById}/${guardId}`, {
  //         method: "get",
  //       });
  //       if (res.status === 1) {
  //         console.log({
  //           phone: parseInt(res.data.phone),
  //         });
  //         const obj = {
  //           name: res.data.name,
  //           userName: res.data.userName,
  //           email: res.data.email,
  //           phone: parseInt(res.data.phone),
  //           //   password: res.data.password,
  //           dob: res.data.dob,
  //           gender: res.data.gender,
  //         };
  //         reset(obj);
  //       }
  //     } catch (error) {
  //       console.log(error);
  //     }
  //   };

  const changePassword = async (data) => {
    try {
      data = {
        ...data,
        id: guard._id,
      };
      const res = await sendRequest(`${ChangeGuardPassword}`, {
        method: "post",
        data,
      });
      if (res.status === 1) {
        onClose();
      }
    } catch (error) {
      console.log({ error });
    }
  };

  return (
    <MainComponentWrapper
    // errorInfo={error}
    //  Loading={loading}
    >
      <ModalWrapper
        title="Change Password"
        submitText={GuardLanguage.Edit.submitText}
        formId="changeGuardPassword"
        CloseModalHandler={onClose}
        dialogClassName="event-guard-modal-dialog"
        contentClassName="event-guard-modal"
        headerClassName="event-guard-modal-header"
        bodyClassName="event-guard-modal-body"
        footerClassName="event-guard-modal-footer"
        closeClass="event-guard-modal-btn-close"
        submitClass="event-guard-modal-btn-primary"
      >
        <form
          className="event-guard-form"
          onSubmit={handleSubmit(changePassword)}
          id="changeGuardPassword"
        >
          <Input
            ValidationArr={[{ Type: "required" }]}
            WrapperClass="col-lg-12"
            element="password"
            FieldName="oldPassword"
            Register={register}
            Errors={errors}
            placeholder="Old Password"
            Label="Old Password"
          />
          <Input
            ValidationArr={[{ Type: "required" }]}
            WrapperClass="col-lg-12"
            element="password"
            FieldName="newPassword"
            Register={register}
            Errors={errors}
            placeholder={"New Password"}
            Label={"New Password"}
          />

          <Input
            ValidationArr={[{ Type: "required" }]}
            WrapperClass="col-lg-12"
            element="password"
            FieldName="confirmPassword"
            Register={register}
            Errors={errors}
            placeholder={"Confirm Password"}
            Label={"Confirm Password"}
          />
        </form>
      </ModalWrapper>
    </MainComponentWrapper>
  );
};

export default ChangePassword;
